<div class="container">
  <mat-card class="login-card">
    <!-- <mat-card-header>
    <mat-card-title>Iniciar sesión</mat-card-title>
  </mat-card-header> -->
    <img
      class="logo"
      [src]="
        themeService.current == 'light'
          ? 'assets/images/nyssa_light.png'
          : 'assets/images/nyssa_dark.png'
      "
      width="200"
      height="120"
      priority
      alt="Collection360 Logo"
    />
    <mat-card-content class="card-content">
      <form
        [formGroup]="loginForm"
        class="login-form"
        (ngSubmit)="onSubmit()"
        autocomplete="on"
      >
        <mat-form-field appearance="fill">
          <mat-label>Usuario</mat-label>
          <mat-icon matPrefix>person</mat-icon>
          <input
            matInput
            type="text"
            formControlName="user"
            name="username"
            autocomplete="username"
            autocapitalize="none"
            autocorrect="off"
            spellcheck="false"
          />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Contraseña</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input
            matInput
            type="password"
            formControlName="password"
            name="password"
            autocomplete="current-password"
            #passwordInput
          />
          <button
            mat-icon-button
            type="button"
            matSuffix
            appPasswordToggle
            [toggleInput]="passwordInput"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </mat-form-field>
        <button mat-flat-button color="primary" type="submit">
          Iniciar Sesión
        </button>
      </form>
    </mat-card-content>
    <mat-card-footer class="card-footer">
      <span>Xera Sistemas © {{ currentYear }}</span>
      @if (loading$ | async) {
        <mat-progress-bar mode="indeterminate" />
      }
    </mat-card-footer>
  </mat-card>
</div>
